<template>
  <footer class="tw-text-1xl tw-ml-10 tw-mb-10 tw-mt-10">
    {{ new Date().getFullYear() }} © Green Medicine Encyclopedia
  </footer>
</template>

<script setup lang="ts"></script>
